import {connect} from 'react-redux';
import Countries from './Countries';
import countryActions from '../../../actions/countries'
import {getListActions, getListState} from '../../../utilites/helpers/crudListHelper';

export default connect(
  (state)=>(getListState(state.countries)),
  (dispatch) => getListActions(countryActions, dispatch)
)(Countries);



// WEBPACK FOOTER //
// ./src/components/form/Countries/index.js